export const MSISDN_REGEX = /^\d{9}$/;
export const ICCID_REGEX = /^\d{20}$/;

export const isValidMsisdn = (value) => MSISDN_REGEX.test(String(value ?? '').trim());
export const isValidIccid = (value) => ICCID_REGEX.test(String(value ?? '').trim());

export const validateBindingRow = ({ msisdn, iccid }) => {
  const errors = [];
  if (!isValidMsisdn(msisdn)) errors.push('MSISDN must be exactly 9 digits');
  if (!isValidIccid(iccid)) errors.push('ICCID must be exactly 20 digits');
  return errors;
};
